import React from 'react'

function Privacidad() {
    return (
        <div className='degradado'>
            <div className="nosotros dos">
                <h2 id='dron' className='subtitulo tres'>
                    POLÍTICA DE PRIVACIDAD
                </h2>
            </div>
            <div className="flexzone">
                <p className='cookies'>
                    1. Datos recopilados: <br />
                    Al utilizar nuestro formulario de contacto, recopilamos los siguientes datos personales: <br />
                    - Nombre y apellido <br />
                    - Dirección de correo electrónico <br />
                    - Mensaje enviado a través del formulario <br /><br />
                    2. Finalidad del tratamiento: <br />
                    Los datos se recogen únicamente para poder responder a su consulta o mensaje. No se usarán para otros fines. <br /><br />
                    3. Responsable del tratamiento:<br />
                    El responsable del tratamiento de los datos es: Verónica Martínez Castillo.<br />
                    Correo electrónico de contacto: info@drontalia.es<br />
                    Domicilio social: C/Imperial 33 02006, Albacete, Castilla La Mancha, España.<br /><br />
                    4. Conservación de los datos:<br />
                    Los datos se conservarán únicamente durante el tiempo necesario para atender su consulta y cumplir con obligaciones legales.<br /><br />
                    5. Derechos del usuario:<br />
                    El usuario puede ejercer en cualquier momento los siguientes derechos:<br />
                    - Acceder a sus datos<br />
                    - Rectificar datos inexactos<br />
                    - Solicitar la supresión de sus datos<br />
                    - Limitar u oponerse al tratamiento<br />
                    - Solicitar la portabilidad de sus datos<br />
                    Para ejercer estos derechos, puede enviar un correo electrónico a info@drontalia.es.<br /><br />
                    6. Cesión de datos:<br />
                    No se cederán los datos personales a terceros, salvo obligación legal.<br /><br />
                    7. Seguridad:<br />
                    Se adoptan medidas técnicas y organizativas para garantizar la seguridad de los datos personales.<br /><br />
                    8. Cambios en la política de privacidad:<br />
                    Nos reservamos el derecho de modificar esta política para adaptarla a novedades legales o cambios en nuestros servicios.<br /><br />
                    9. Legislación aplicable:<br />
                    La presente política se rige por la normativa española vigente y la normativa europea de protección de datos personales.
                </p>
            </div>
        </div>
    )
}

export default Privacidad
